'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { isNativePlatform } from '@/lib/native';

export default function Home() {
  const router = useRouter();
  useEffect(() => {
    // Native app (and the `?native=1` desktop preview) opens the mobile home;
    // the plain web app goes to the admin/dashboard area. isNativePlatform() is
    // client-only, so this runs after mount rather than as a server redirect.
    router.replace(isNativePlatform() ? '/mobile/home' : '/app');
  }, [router]);
  return null;
}
